/**
 * Edit systems item component
 */

// React
import React, { FC } from 'react';

// Material
import { Box, Typography } from '@mui/material';

// Components
import AppDate from 'components/AppDate';

// Common styles
import { ContentSystem, ContentSystemItem } from 'styles';
import styled from '@emotion/styled';

// Interface
interface EditDateSystemProps {
  control: any;
  errors: any;
}

// Styles
export const TypographySystem = styled(Typography)(() => ({
  color: '#666666',
  fontWeight: '700',
  minWidth: '140px',
}));

// Component
const EditDateSystem: FC<EditDateSystemProps> = ({ control, errors }) => {
  return (
    <Box>
      <Box display="flex">
        <Box width={'100px'}></Box>
        <ContentSystem>
          <ContentSystemItem>
            <TypographySystem>開始日</TypographySystem>
            <AppDate
              control={control}
              name="start_date"
              helperText={errors?.systems?.start_date?.message}
            />
          </ContentSystemItem>
          <ContentSystemItem>
            <TypographySystem>終了日</TypographySystem>

            <AppDate
              name="end_date"
              control={control}
              helperText={errors?.systems?.end_date?.message}
            />
          </ContentSystemItem>
        </ContentSystem>
      </Box>
    </Box>
  );
};

export default EditDateSystem;
